export const profiles = [
  {
    id: 'dadda-cool',
    name: 'Dadda Cool',
    title: 'AI Music Artist & Sound Architect',
    about: 'Pioneering the future of sound through artificial intelligence. I merge classical music theory with advanced generative algorithms to create immersive auditory experiences. My work with Suno AI and Udio has been featured in digital galleries worldwide.',
    avatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=400&h=400&fit=crop',
    email: 'dadda@futuremusic.ai',
    phone: '+1 555-0199',
    location: 'Metaverse / San Francisco',
    website: 'www.daddacool.ai',
    socials: { 
      linkedin: 'linkedin.com/in/daddacool', 
      x: 'x.com/daddacool_ai', 
      github: 'github.com/daddacool', 
      youtube: 'youtube.com/c/daddacool_music' 
    },
    education: [
      { year: '2023', degree: 'Master of AI Arts', school: 'Digital Arts Institute' },
      { year: '2020', degree: 'B.S. Computer Science', school: 'Tech University' }
    ],
    experience: [
      { year: '2023 - Present', company: 'Suno AI', role: 'Lead Prompt Engineer', desc: 'Pushing the boundaries of generative audio. Collaborating with algorithms to compose chart-topping AI symphonies.' },
      { year: '2021 - 2023', company: 'Udio Labs', role: 'Sound Designer', desc: 'Developed core soundscapes for the next generation of music generation tools.' }
    ],
    skills: ['Suno AI', 'Udio', 'Python', 'Music Theory', 'Prompt Engineering', 'Sound Design', 'Generative Art'],
    languages: ['English', 'Python', 'Musical Notation'],
    references: [
      { name: 'Elon M.', role: 'CEO', company: 'Future Corp', contact: 'elon@future.com' },
      { name: 'Grimes', role: 'Artist', company: 'Independent', contact: 'management@grimes.com' }
    ]
  },
  {
    id: 'elara-vance',
    name: 'Elara Vance',
    title: 'UX Researcher',
    about: 'Dedicated to understanding user behavior and translating insights into intuitive design. I believe in empathy-driven development.',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    email: 'elara@uxdesign.com',
    phone: '555-0101',
    location: 'Austin, TX',
    website: 'www.elaraux.com',
    socials: { linkedin: 'linkedin.com/in/elara', github: 'github.com/elara' },
    education: [
      { year: '2019', degree: 'M.S. HCI', school: 'Georgia Tech' }
    ],
    experience: [
      { year: '2020 - Present', company: 'Google', role: 'UX Researcher', desc: 'Leading user studies for Maps accessibility features.' }
    ],
    skills: ['User Testing', 'Figma', 'Accessibility', 'Data Analysis'],
    languages: ['English', 'Spanish'],
    references: [{ name: 'Jane Doe', role: 'Director', company: 'Google', contact: 'jane@google.com' }]
  },
  {
    id: 'liam-chen',
    name: 'Liam Chen',
    title: 'Full Stack Developer',
    about: 'Building scalable web applications with the MERN stack. Passionate about clean code and performance optimization.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    email: 'liam@code.dev',
    phone: '555-0102',
    location: 'Toronto, Canada',
    website: 'www.liamchen.dev',
    socials: { github: 'github.com/liamc', linkedin: 'linkedin.com/in/liamc' },
    education: [{ year: '2018', degree: 'B.Sc. Computer Science', school: 'University of Toronto' }],
    experience: [{ year: '2019 - Present', company: 'Shopify', role: 'Senior Dev', desc: 'Optimizing checkout flows.' }],
    skills: ['React', 'Node.js', 'MongoDB', 'GraphQL', 'AWS'],
    languages: ['English', 'Mandarin'],
    references: []
  },
  {
    id: 'sophia-rossi',
    name: 'Sophia Rossi',
    title: 'Digital Marketing Specialist',
    about: 'Crafting viral campaigns and building brand identity. Expert in SEO and social media growth strategies.',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
    email: 'sophia@marketing.pro',
    phone: '555-0103',
    location: 'Milan, Italy',
    website: 'www.sophiarossi.it',
    socials: { instagram: 'instagram.com/sophia', linkedin: 'linkedin.com/in/sophia' },
    education: [{ year: '2020', degree: 'Marketing Mgmt', school: 'Bocconi University' }],
    experience: [{ year: '2021 - Present', company: 'Vogue', role: 'Social Lead', desc: 'Managing digital presence.' }],
    skills: ['SEO', 'Content Marketing', 'Analytics', 'Copywriting'],
    languages: ['Italian', 'English', 'French'],
    references: []
  },
  {
    id: 'marcus-johnson',
    name: 'Marcus Johnson',
    title: 'Data Scientist',
    about: 'Turning complex data into actionable business insights. Proficient in Python, R, and Machine Learning models.',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    email: 'marcus@data.io',
    phone: '555-0104',
    location: 'Chicago, IL',
    website: 'www.marcusdata.com',
    socials: { github: 'github.com/marcusj', linkedin: 'linkedin.com/in/marcusj' },
    education: [{ year: '2017', degree: 'Ph.D. Statistics', school: 'UChicago' }],
    experience: [{ year: '2018 - Present', company: 'IBM', role: 'Data Scientist', desc: 'Developing predictive models.' }],
    skills: ['Python', 'TensorFlow', 'SQL', 'Tableau'],
    languages: ['English'],
    references: []
  },
  {
    id: 'priya-patel',
    name: 'Priya Patel',
    title: 'Product Manager',
    about: 'Bridging the gap between engineering, design, and business. Focused on delivering products that solve real problems.',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
    email: 'priya@pm.com',
    phone: '555-0105',
    location: 'London, UK',
    website: 'www.priyapm.com',
    socials: { linkedin: 'linkedin.com/in/priya' },
    education: [{ year: '2016', degree: 'MBA', school: 'LBS' }],
    experience: [{ year: '2017 - Present', company: 'Revolut', role: 'Senior PM', desc: 'Leading fintech innovation.' }],
    skills: ['Agile', 'Jira', 'Strategy', 'Leadership'],
    languages: ['English', 'Hindi', 'Gujarati'],
    references: []
  },
  {
    id: 'alex-kovacs',
    name: 'Alex Kovacs',
    title: '3D Artist & Animator',
    about: 'Creating stunning visual effects and 3D animations for games and film. Master of Blender and Maya.',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
    email: 'alex@3d.art',
    phone: '555-0106',
    location: 'Budapest, Hungary',
    website: 'www.alexkovacs.art',
    socials: { dribbble: 'dribbble.com/alex', linkedin: 'linkedin.com/in/alex' },
    education: [{ year: '2019', degree: 'Animation', school: 'MOME' }],
    experience: [{ year: '2020 - Present', company: 'Ubisoft', role: '3D Artist', desc: 'Character modeling for AAA titles.' }],
    skills: ['Blender', 'Maya', 'ZBrush', 'Unreal Engine'],
    languages: ['Hungarian', 'English'],
    references: []
  },
  {
    id: 'yuki-tanaka',
    name: 'Yuki Tanaka',
    title: 'Mobile Developer',
    about: 'iOS and Android expert specializing in Flutter and Swift. Creating smooth, responsive mobile experiences.',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
    email: 'yuki@mobile.dev',
    phone: '555-0107',
    location: 'Tokyo, Japan',
    website: 'www.yukidevs.com',
    socials: { github: 'github.com/yuki', twitter: 'x.com/yuki' },
    education: [{ year: '2018', degree: 'Computer Science', school: 'University of Tokyo' }],
    experience: [{ year: '2019 - Present', company: 'Line Corp', role: 'iOS Lead', desc: 'Messaging app optimization.' }],
    skills: ['Swift', 'Flutter', 'Kotlin', 'Firebase'],
    languages: ['Japanese', 'English'],
    references: []
  },
  {
    id: 'olivia-brown',
    name: 'Olivia Brown',
    title: 'Content Writer',
    about: 'Weaving words that captivate and convert. Experienced in technical writing, blogging, and creative storytelling.',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=400&fit=crop',
    email: 'olivia@write.com',
    phone: '555-0108',
    location: 'New York, NY',
    website: 'www.oliviawrites.com',
    socials: { linkedin: 'linkedin.com/in/olivia', twitter: 'x.com/olivia' },
    education: [{ year: '2017', degree: 'English Lit', school: 'NYU' }],
    experience: [{ year: '2018 - Present', company: 'Medium', role: 'Editor', desc: 'Curating top stories.' }],
    skills: ['Copywriting', 'Editing', 'SEO', 'WordPress'],
    languages: ['English'],
    references: []
  },
  {
    id: 'carlos-mendez',
    name: 'Carlos Mendez',
    title: 'Cybersecurity Analyst',
    about: 'Protecting digital assets from evolving threats. Certified Ethical Hacker with a focus on network security.',
    avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
    email: 'carlos@secure.net',
    phone: '555-0109',
    location: 'Madrid, Spain',
    website: 'www.carlossec.com',
    socials: { linkedin: 'linkedin.com/in/carlos', github: 'github.com/carlos' },
    education: [{ year: '2016', degree: 'Cybersecurity', school: 'Polytechnic U' }],
    experience: [{ year: '2017 - Present', company: 'Telefonica', role: 'Security Lead', desc: 'Network defense.' }],
    skills: ['Penetration Testing', 'Python', 'Linux', 'Network Security'],
    languages: ['Spanish', 'English'],
    references: []
  }
];